import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../../shared/base-components/base.component';

export class TsaSecurityThreatHistoryModalContext {
    constructor(public customerNumberId: number) {}
}

@Component({
    selector: 'tsa-security-threat-history-modal',
    templateUrl: './tsa-security-threat-history-modal.html'
})
export class TsaSecurityThreatHistoryModalComponent extends BaseComponent {

    constructor(
        public dialogRef: MatDialogRef<TsaSecurityThreatHistoryModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: TsaSecurityThreatHistoryModalContext) {
        super();
    }

    public ngOnInit() {
    }

    public close = (): void => {
        this.dialogRef.close();
    };
}
